import { render, staticRenderFns } from "./bfcheckbox1.vue?vue&type=template&id=1fb4a774&scoped=true"
import script from "./bfcheckbox1.vue?vue&type=script&lang=js"
export * from "./bfcheckbox1.vue?vue&type=script&lang=js"
import style0 from "./bfcheckbox1.vue?vue&type=style&index=0&id=1fb4a774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4a774",
  null
  
)

export default component.exports